module.exports = __webpack_public_path__ + "img/9C.355e3eac.png";